
    import Utils from '../common/utils/utils';
    import { defineComponent, PropType, ref } from 'vue';
    import { ILibraryComponent, ILibraryComponentCategory, ILibraryComponentList } from '../library/types';
    import { default as SideBarMenu } from './SideBarMenu.vue';

    export default defineComponent({
        name: "LibraryPage",
        props: {
            title: { type: String, required: true },
            initialComponentName: { type: String, required: true },
            componentList: { type: Object as PropType<ILibraryComponentList>, required: true }
        },
        components: {
            SideBarMenu
        },
        setup(props, _context) {
            let currentComponentName = ref<string>(props?.initialComponentName ?? null);

            return {
                currentComponentName,
                categories: props?.componentList?.categories ?? []
            }
        },
        methods: {
            getComponentId(id: string): string {
                if (!id)
                    return '';

                return 'Component-' + id.toLowerCase().trim();
            },
            onMenu_ComponentSelected(comp: ILibraryComponent) {
                let elemId = this.getComponentId(comp.id);
                let elemRef = Utils.getElemFromRefs(this.$refs, elemId);
                elemRef?.scrollIntoView?.();

                this.$router.push({ name: 'uiComponentSpecific', params: { component: comp.id } });
            },
            getLibraryComponents(cat: ILibraryComponentCategory) {
                return cat?.components?.filter(c => c.libraryComponent != null) ?? [];
            }
        },
        mounted() {
            var compToView = this.$route.params?.component as string;

            if (!!compToView) {
                let elemId = this.getComponentId(compToView);
                let elemRef = Utils.getElemFromRefs(this.$refs, elemId);
                elemRef?.scrollIntoView?.();
            }
        }
    });
